import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { CommandPalette } from '../components/CommandPalette';
import { WarmingBanner } from '../components/WarmingBanner';
import { ErrorBoundary } from '../components/ErrorBoundary';

export function Layout() {
  const location = useLocation();
  return (
    <>
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Sidebar />
      <main className="main-content" id="main-content">
        <WarmingBanner />
        <div className="page-container" key={location.pathname}>
          <ErrorBoundary key={location.pathname}>
            <Outlet />
          </ErrorBoundary>
        </div>
      </main>
      <CommandPalette />
    </>
  );
}
